import $ from 'jquery'
import { viewModalEvent } from 'application/ga_view_modal_event'
import { createAppVideoPlayer } from 'video/videoJsPlayer'

function foundationPagesIndex($element) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $higherEdForm,
      $createAccountForm;

  // constructor
  function init() {
    $(() => {
      $(document).foundation();
      SOPHIA.clickLinkForGA($('body.flexible-layout:not(.touchstone-grading-page)'));
    });

    const $createAccountOverlay = $('#create-account-overlay')

    $(document).on('closeme.zf.reveal', '#create-account-overlay[data-reveal]', function() {
      $('.form-field__errors').remove()
      $('.form-field__input', $createAccountOverlay).val('')
      $('.form-field.field_with_errors', $createAccountOverlay).removeClass('field_with_errors')
      $('.password-hint-list .icon-checkmark', $createAccountOverlay).removeClass('checked')
      $('.form-field', $createAccountOverlay).removeClass('form-field--is-filled')
    })

    $createAccountForm = $('#header-sign-up-form', $mainContainer);

    if ($createAccountForm) {
      $createAccountForm.formMaterialDesign();
    }

    Foundation.Magellan.defaults.deepLinking = true;

    $(window).on('load', function() {
      SOPHIA.stickyHeaderForTable();
    });

    $higherEdForm = $('.higher-education-form', $mainContainer);

    // GA reveal modals events
    $("a[data-open]").off('click.openzf').on('click.openzf', function(e) {
      $(document).on('open.zf.reveal', '[data-reveal]', () => {
        if ($(e.target).data('open') != "create-account-overlay") { // to prevent double event
          viewModalEvent({})
        }

        $('.close-reveal-modal').off('click.close').on('click.close', (e) => {
          SOPHIA.clickModalCloseForGA($(e.target), $('[data-reveal]'))
        });
      });

      $(document).on('closed.zf.reveal', '[data-reveal]', () => {
        if ($(e.target).data('open') != "create-account-overlay") { // to prevent double event
          SOPHIA.clickModalCloseForGA(false, $('[data-reveal]'))
        }

        $(document).off('closed.zf.reveal', '[data-reveal]').off('open.zf.reveal', '[data-reveal]')
      })
    });

    $(document).on('closed.zf.reveal', '[data-reveal]', function() {
      var $videoIframe  = $('.ace-marketing-youtube-video iframe')
      var videoSrc = $videoIframe.prop('src')

      $videoIframe.prop('src', '').prop('src', videoSrc);

    });

    $('.primary-interstitial-cta').on('click', function() {
      snowplow('trackStructEvent', {
        category: 'Interstitial CTA',
        action: 'CTA Click',
        label: 'Interstitial CTA'
      });

    });

    $('.become-a-member-btn').on('click', () => {
      snowplow('trackStructEvent', {
        category: 'tier_2_landing',
        action: 'click',
        label: 'become_a_member'
      });
    });

    $('.try-for-free-btn').on('click', () => {
      snowplow('trackStructEvent', {
        category: 'tier_2_landing',
        action: 'click',
        label: 'try_for_free'
      });
    })
    
    bindDomEvents();
  }

  /* PRIVATE METHODS */

  function bindDomEvents() {
    if ($('.slideshow').length > 0) {
      $('.slideshow').slick({
        dots: true
      });
    }

    if ($('.shortcode-video').length) {
      createAppVideoPlayer($('.shortcode-video'))
    }

    $higherEdForm.formMaterialDesign();
    higherEdFormValidation();
    $('input', $higherEdForm).on('keyup', higherEdFormValidation);

    $('.course-detail-page__reviews').on('click', '.more_link', viewMore);

    $('.see-the-courses').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 35
      }, 800);
    });

    $mainContainer.explainOverlay();
    $mainContainer.deacExplainOverlay();
  }

  function viewMore(event) {
    event.preventDefault();
    var $link = $(this),
        href = $link.attr('href');

    var xhrData = {
      url: href,
      type: 'get',
      dataType: 'json'
    };
    var callbacks = {
      afterSuccess: function(data) {
        $('.course-detail-review-wrapper').append(data.html);
        if (data.last_page) {
          $link.remove();
        } else {
          var new_href = $link.attr('href').replace('page='+data.current_page,'page='+(data.current_page+1));
          $link.attr('href', new_href);
        }
      }
    };

    SOPHIA.sendXHR(xhrData, callbacks);
  }

  function higherEdFormValidation() {
    var inputs = [],
        $button = $('.f-button', $higherEdForm);
    $button.attr('disabled','disabled').addClass('disabled');

    $('input[type="text"], input[type="email"]', $higherEdForm).each(function() {
      if ($(this).val() == '') {
        inputs.push($(this));
      }
    });

    if (inputs.length == 0) {
      $button.removeAttr('disabled').removeClass('disabled');
    }
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };

}

// jQuery plugin method
$.fn.foundationPagesIndex = function() {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('foundationPagesIndex')) {
      $this.data('foundationPagesIndex', foundationPagesIndex($this));
    }
  });
};
